import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
// Load E2E test helpers (has internal guard for dev/test only)
import "./test/e2e-helpers";

// Initialize Sentry BEFORE rendering the app
initSentry();

// Wrap the entire app with Sentry's ErrorBoundary
const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: ({ error, componentStack, resetError }) => (
    <div className="flex items-center justify-center min-h-screen bg-background p-4">
      <div className="max-w-md w-full bg-card border border-border rounded-lg p-6 space-y-4">
        <h1 className="text-2xl font-bold text-destructive">Oops! Something went wrong</h1>
        <p className="text-muted-foreground">
          We've been notified and are looking into it. You can try refreshing the page.
        </p>
        <details className="text-sm">
          <summary className="cursor-pointer text-muted-foreground hover:text-foreground">
            Error Details
          </summary>
          <pre className="mt-2 p-2 bg-muted rounded text-xs overflow-auto">
            {error?.toString()}
            {componentStack}
          </pre>
        </details>
        <div className="flex gap-2">
          <button
            onClick={resetError}
            className="px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90"
          >
            Try Again
          </button>
          <button
            onClick={() => window.location.href = '/'}
            className="px-4 py-2 bg-secondary text-secondary-foreground rounded hover:bg-secondary/90"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  ),
  showDialog: true, // Show Sentry's user feedback dialog
});

createRoot(document.getElementById("root")!).render(<SentryApp />);
